export default function listenForOutsideClicks(
  listening,
  setListening,
  popoverDropdownRef,
  btnDropdownRef,
  setDropdownPopoverShow
) {
  return () => {
    if (listening) return;
    if (!popoverDropdownRef.current && btnDropdownRef.current) return;
    setListening(true);
    [`click`, `touchstart`].forEach((type) => {
      document.addEventListener(`click`, (evt) => {
        const cur = popoverDropdownRef.current;
        const node = evt.target;
        if (cur && cur.contains(node)) return;
        setDropdownPopoverShow(false);
      });
    });
  };
}
